export default __webpack_public_path__ + "static/media/REQ_Transparent.ad82b475.png";